import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import counterReducer, { CounterState } from '../reducer/counterSlice';
import { rootSaga } from '../sagas/sagas';
import contentfulReducer, { ContentfulState } from '../reducer/contentfulSlice';
import authReducer, { AuthState } from '../reducer/authSlice';
import userReducer from '../reducer/userSlice';
import rewardsReducer, { RewardsState } from '../reducer/rewardsSlice';
import transactionsReducer from '../reducer/transactionsSlice';
import userAccountDetailsReducer from '../reducer/userAccountDeatilsSlice';
import accountReducer, { AccountState } from '../reducer/accountSlice';
import changePasswordReducer, {
  ChangePasswordState,
} from '../reducer/changePasswordSlice';
import changePinReducer, { ChangePinState } from '../reducer/changePinSlice';
import eppReducer, { EPPState } from '../reducer/eppSlice';
import cardLockReducer, { CardLockState } from '../reducer/cardLockSlice';
import popupReducer, { PopupState } from '../reducer/popupSlice';
import statementsReducer, { StatementState } from '../reducer/statementsSlice';
import transactionsDownloadReducer, {
  DownloadTransaction,
} from '../reducer/transactionsDownloadSlice';
import preferencesUserReducer, {
  preferencesUserState,
} from '../reducer/preferencesUserSlice';
import generateCodeReducer, {
  generateCodeForDeviceState,
} from '../reducer/generateCodeDeviceSlice';
import validatePasscodeReducer, {
  validatePasscodeState,
} from '../reducer/validatePasscodeSlice';
import resetReducer, { ResetState } from '../reducer/resetSlice';
import { watchPopupStatusSagas } from '../sagas/popupSaga';
import { watchResetSaga } from '../sagas/resetSaga';
import redeemRewardsReducer, {
  redeemRewardsState,
} from '../reducer/redeemRewardsSlice';
import { watchRewardsRedeemersSagas } from '../sagas/redeemRewardsSaga';
import contactInfoReducer, {
  ContactInfoState,
} from '../reducer/contactInfoSlice';
import myProfileReducer, { MyProfileState } from '../reducer/myProfileSlice';
import { watchContactInfoSagas } from '../sagas/contactInfoSaga';
import profileReducer, { profileState } from '../reducer/profileSlice';
import { watchEmployeeProfileSagas } from '../sagas/profileSaga';
import { watchChangePasswordSaga } from '../sagas/changePasswordSaga';
import supplemeantryReducer, {
  SupplemeantryState,
} from '../reducer/supplemeantrySlice';
import { watchSupplemeantrySagas } from '../sagas/supplemeantrySaga';
import manageAlertsReducer from '../reducer/manageAlertsSlice';
import smsVerificationReducer, {
  SmsVerificationState,
} from '../reducer/smsVerificationSlice';
import { watchRequestCardSagas } from '../sagas/requestCardSaga';
import requestCardReducer, {
  RequestCardState,
} from '../reducer/requestCardSlice';
import { watchChangePinSaga } from '../sagas/changePinSaga';
import banLinkageReducer, { BANLinkageState } from '../reducer/banLinkageSlice';
import watchBanLinkageSaga from '../sagas/banLinkageSaga';
import disclosureSummaryReducer from '../reducer/disclosureSummarySlice';
import { watchDisclosureSummarySaga } from '../sagas/disclosureSummarySaga';
import { watchValidatePasscodeSaga } from '../sagas/validatePasscodeSaga';
import contactDetailsReducer from '../reducer/contactDetailsSlice';
import { ContactDetailsState } from '../reducer/contactDetailsSlice';
import { watchOfferSagas } from '../sagas/offerSaga';
import offerReducer, { OfferState } from '../reducer/offerSlice';
import loyaltyHubReducer, { lhState } from '../reducer/loyaltyHubslice';
import { watchLoyltyHubSagas } from '../sagas/loyaltyHubSaga';
import entertainmentCreditReducer, {
  EntertainmentCreditState,
} from '../reducer/entertainmentCreditSlice';
import accountProtectionReducer, {
  AccountProtectionState,
} from '../reducer/accountProtectionSlice';
import { watchEntertainmentCreditSubmit } from '../sagas/entertainmentCreditSaga';
import { watchAccountProtectionDetails } from '../sagas/accountProtectionSaga';
import userLocationReducer, {
  UserLocationState,
} from '../reducer/userLocationSlice';
import passkeyRegisterReducer, {
  PasskeyRegisterState,
} from '../reducer/passkeyRegisterSlice';
import { watchPasskeyRegisterSaga } from '../sagas/passkeyRegisterSaga';
import passkeyOtpPreferencesReducer, {
  PasskeyOtpPreferencesState,
} from '../reducer/passkeyOtpPreferencesSlice';
import passkeyOtpGenerateReducer, {
  PasskeyOtpGenerateState,
} from '../reducer/passkeyOtpGenerateSlice';
import passkeyOtpValidateReducer, {
  PasskeyOtpValidateState,
} from '../reducer/passkeyOtpValidateSlice';
import { watchPasskeyOtpPreferencesSaga } from '../sagas/passkeyOtpPreferencesSaga';
import { watchPasskeyOtpGenerateSaga } from '../sagas/passkeyOtpGenerateSaga';
import { watchPasskeyOtpValidateSaga } from '../sagas/passkeyOtpValidateSaga';
import passkeyDeregisterReducer, {
  PasskeyDeregisterState,
} from '../reducer/passkeyDeregisterSlice';
import { watchPasskeyDeregisterSaga } from '../sagas/passkeyDeregisterSaga';
import passkeyStatusReducer, {
  PasskeyStatusState,
} from '../reducer/passkeyStatusSlice';
import { watchPasskeyStatusSaga } from '../sagas/passkeyStatusSaga';
import passkeyListReducer, {
  PasskeyListState,
} from '../reducer/passkeyListSlice';
import { watchPasskeyListSaga } from '../sagas/passkeyListSaga';

const sagaMiddleware = createSagaMiddleware();

export interface RootState {
  cardLock: CardLockState;
  account: AccountState;
  counter: CounterState;
  contentful: ContentfulState;
  auth: AuthState;
  user: any;
  rewards: RewardsState;
  transactions: any;
  epp: EPPState;
  changePassword: ChangePasswordState;
  changePin: ChangePinState;
  statements: StatementState;
  downloadTransactions: DownloadTransaction;
  preferencesUser: preferencesUserState;
  generateCode: generateCodeForDeviceState;
  validatePasscode: validatePasscodeState;
  popup: PopupState;
  contactInfo: ContactInfoState;
  reset: ResetState;
  redeemRewards: redeemRewardsState;
  profile: profileState;
  myProfile: MyProfileState;
  supplemeantry: SupplemeantryState;
  manageAlerts: any;
  smsVerification: SmsVerificationState;
  requestCard: RequestCardState;
  banLinkage: BANLinkageState;
  disclosureSummary: any;
  contactDetails: ContactDetailsState;
  offer: OfferState;
  loyaltyHub: lhState;
  entertainmentCredit: EntertainmentCreditState;
  accountProtection: AccountProtectionState;
  userLocation: UserLocationState;
  passkeyRegister: PasskeyRegisterState;
  passkeyOtpPreferences: PasskeyOtpPreferencesState;
  passkeyOtpGenerate: PasskeyOtpGenerateState;
  passkeyOtpValidate: PasskeyOtpValidateState;
  passkeyDeregister: PasskeyDeregisterState;
  passkeyStatus: PasskeyStatusState;
  passkeyList: PasskeyListState;
}

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    contentful: contentfulReducer,
    auth: authReducer,
    user: userReducer,
    rewards: rewardsReducer,
    transactions: transactionsReducer,
    useraccountDetails: userAccountDetailsReducer,
    account: accountReducer,
    epp: eppReducer,
    changePassword: changePasswordReducer,
    changePin: changePinReducer,
    cardLock: cardLockReducer,
    statements: statementsReducer,
    downloadTransactions: transactionsDownloadReducer,
    preferencesUser: preferencesUserReducer,
    generateCode: generateCodeReducer,
    validatePasscode: validatePasscodeReducer,
    popup: popupReducer,
    contactInfo: contactInfoReducer,
    reset: resetReducer,
    redeemRewards: redeemRewardsReducer,
    myProfile: myProfileReducer,
    profile: profileReducer,
    supplemeantry: supplemeantryReducer,
    manageAlerts: manageAlertsReducer,
    smsVerification: smsVerificationReducer,
    requestCard: requestCardReducer,
    banLinkage: banLinkageReducer,
    disclosureSummary: disclosureSummaryReducer,
    contactDetails: contactDetailsReducer,
    offer: offerReducer,
    loyaltyHub: loyaltyHubReducer,
    entertainmentCredit: entertainmentCreditReducer,
    accountProtection: accountProtectionReducer,
    userLocation: userLocationReducer,
    passkeyRegister: passkeyRegisterReducer,
    passkeyOtpPreferences: passkeyOtpPreferencesReducer,
    passkeyOtpGenerate: passkeyOtpGenerateReducer,
    passkeyOtpValidate: passkeyOtpValidateReducer,
    passkeyDeregister: passkeyDeregisterReducer,
    passkeyStatus: passkeyStatusReducer,
    passkeyList: passkeyListReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);
sagaMiddleware.run(watchPopupStatusSagas);
sagaMiddleware.run(watchResetSaga);
sagaMiddleware.run(watchRewardsRedeemersSagas);
sagaMiddleware.run(watchContactInfoSagas);
sagaMiddleware.run(watchEmployeeProfileSagas);
sagaMiddleware.run(watchChangePasswordSaga);
sagaMiddleware.run(watchChangePinSaga);
sagaMiddleware.run(watchSupplemeantrySagas);
sagaMiddleware.run(watchRequestCardSagas);
sagaMiddleware.run(watchBanLinkageSaga);
sagaMiddleware.run(watchDisclosureSummarySaga);
sagaMiddleware.run(watchValidatePasscodeSaga);
sagaMiddleware.run(watchOfferSagas);
sagaMiddleware.run(watchLoyltyHubSagas);
sagaMiddleware.run(watchEntertainmentCreditSubmit);
sagaMiddleware.run(watchAccountProtectionDetails);
sagaMiddleware.run(watchPasskeyRegisterSaga);
sagaMiddleware.run(watchPasskeyOtpPreferencesSaga);
sagaMiddleware.run(watchPasskeyOtpGenerateSaga);
sagaMiddleware.run(watchPasskeyOtpValidateSaga);
sagaMiddleware.run(watchPasskeyDeregisterSaga);
sagaMiddleware.run(watchPasskeyStatusSaga);
sagaMiddleware.run(watchPasskeyListSaga);

export type AppDispatch = typeof store.dispatch;
